import atom from "../logo.svg";
import bg from "../casper-ctx-bg.svg";
import "./CasperHero.css";

export default function CasperHero() {
  return (
    <div className="casper-hero">
      <svg
        viewBox="0 0 1200 800"
        preserveAspectRatio="xMidYMid meet"
        className="casper-svg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background */}
        <image href={bg} x="0" y="0" width="1200" height="800" />

        {/* Top text */}
        <text
          x="600"
          y="90"
          textAnchor="middle"
          className="hero-title"
        >
          {_$_appMessage}
        </text>

        {/* Atom pinned to hand */}
        <image
          href={atom}
          x="700"
          y="280"
          width="120"
          height="120"
          className="atom-spin"
        />
      </svg>
    </div>
  );
}
